module.exports = __webpack_public_path__ + "static/img/top-left.e29304a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/design/top-left.png
// module id = /Pa5
// module chunks = 0